import { useSnackbar, VariantType } from "notistack";
import React from "react";
import { XButton } from "../components/Styled/XButton";
const uuid = require("uuid");

export const SnackbarAction: React.FC<{ snackbarId: string }> = ({
  snackbarId,
}) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <>
      <XButton
        color="#FFF"
        width={18}
        onClick={() => {
          closeSnackbar(snackbarId);
        }}
      />
    </>
  );
};

export function useDismissableSnackbar() {
  const { enqueueSnackbar } = useSnackbar();

  const showSnackbar = (message: string, variant: VariantType) => {
    const snackbarId = uuid.v4();
    enqueueSnackbar(message, {
      key: snackbarId,
      variant,
      preventDuplicate: true,
      action: <SnackbarAction snackbarId={snackbarId} />,
    });
  };

  return {
    showSnackbar: showSnackbar,
  };
}
